import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { AgGridEvrideoCustomLoadingOverlayComponent } from "../ag-grid-evrideo/ag-grid-evrideo-custom-loading-overlay/ag-grid-evrideo-custom-loading-overlay.component";

@Component({
  selector: "evrideo-visibility-icon",
  templateUrl: "./visibility-icon.component.html",
  styleUrl: "./visibility-icon.component.scss",
})
export class VisibilityIconComponent {
  @Input() isVisible: boolean = false;
  @Output() onVisibilityChange = new EventEmitter<void>();
  constructor(private _changeDetectorRef: ChangeDetectorRef) {}
}
